/**
 * EntradasSaidasMesWidget - entradas e saidas do mes corrente.
 */
import React from "react";
import { Link } from "react-router-dom";

import { obterResumoFinanceiro } from "../../../services/financeiro";

import { CardBody, KpiSub, LinkLight, CardFooter } from "../styles";


export const meta = {
  id: "entradas_saidas_mes",
  label: "Entradas e saidas (mês)",
  descricao: "Total de entradas e saidas confirmadas no mês corrente.",
  categoria: "Financeiro",
  permissoes: ["financeiro:view"],
  tamanho_default: "M",
  essencial: false,
};

export async function fetchData(request) {
  return await obterResumoFinanceiro(request);
}

function fmt(v) {
  if (v === null || v === undefined) return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return "—";
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
}

export function Widget({ dados }) {
  const ent = dados?.entradas_mes ?? dados?.entradas ?? null;
  const sai = dados?.saidas_mes ?? dados?.saidas ?? null;
  const saldo_mes = (Number(ent) || 0) - (Number(sai) || 0);
  return (
    <>
      <CardBody>
        <div style={{ display: "flex", gap: 12 }}>
          <div style={{ flex: 1 }}>
            <KpiSub>Entradas</KpiSub>
            <div style={{ fontSize: "1.2rem", fontWeight: 700, color: "var(--success-text)" }}>{fmt(ent)}</div>
          </div>
          <div style={{ flex: 1 }}>
            <KpiSub>Saidas</KpiSub>
            <div style={{ fontSize: "1.2rem", fontWeight: 700, color: "var(--danger-text)" }}>{fmt(sai)}</div>
          </div>
        </div>
        <KpiSub style={{ marginTop: 6 }}>
          Saldo do mes: <strong>{fmt(saldo_mes)}</strong>
        </KpiSub>
      </CardBody>
      <CardFooter>
        <LinkLight as={Link} to="/financeiro/dashboard">Ver financeiro</LinkLight>
      </CardFooter>
    </>
  );
}
